import { useLocation, useNavigate } from 'react-router-dom';
import BackIcon from '../../../assets/icons/trvto_ArrowBack.svg';
import styles from './orgActivityPackUpload.module.css';
import { useEffect, useRef, useState } from 'react';
import ReactLoading from 'react-loading';
import ActivityBasic from '../../../components/Activity/orgActivityUploadSection/activityBasic/ActivityBasic';
import ActivityQuickView from '../../../components/Activity/orgActivityUploadSection/activityQuickView/ActivityQuickView';
import AddTimeSlots from '../../../components/Activity/orgActivityUploadSection/addTimeSlots/AddTimeSlots';
import ImageUpOrg from '../../../components/packUploadSection/images/ImageUpOrg';
import InEx from '../../../components/packUploadSection/inEx/InEx';
import Safety from '../../orgPackUpload/orgPackUploadSection/safety/safety';
import ThingsToCarry from '../../orgPackUpload/orgPackUploadSection/thingsToCarry/thingsToCarry';
import FAQ from '../../../components/packUploadSection/FAQ/FAQ';
import Terms from '../../orgPackUpload/orgPackUploadSection/terms/Terms';
import Tags from '../../../components/tags/Tags';
import ActivityPrice from '../../../components/Activity/orgActivityUploadSection/activityPrice/ActivityPrice';
import ItinerarySection from '../../../components/reusable-ui-components/itinerarySection/ItinerarySection';
import ActivityGroupPrice from '../../../components/Activity/orgActivityUploadSection/activityGroupPrice/ActivityGroupPrice';
import GuidPickup from '../../../components/Guid/orgGuidPackUploadSection/guidPickup/GuidPickup';
import DownArrow from '../../../assets/icons/down-arrow.svg';
import UpArrow from '../../../assets/icons/up-arrow.svg';
import orgActUpSubmit from './activityUpFun/activityUpSubmit';
import { orgActDetailsFun } from '../../../api/orgActAPI';
import errorHandle from '../../../utils/errorHandle';
import ActivityMeetup from '../../../components/Activity/orgActivityUploadSection/actMeetup/ActivityMeetup';

const initialActivityState = {
    _id: '',
    title: '',
    overview: '',
    timeSlots: [''],
    days: '',
    openTime: '',
    closeTime: '',
    quickView: {
        type: [],
        difficulty: '',
        duration: '',
        trekDistance: '',
        baseCities: [],
        maxSlots: '',
        area: ''
    },
    itinerary: [
        {
            dayHeading: '',
            dayDescription: ''
        }
    ],
    FAQ: [{ question: '', answer: '' }],
    price: [
        {
            actual: null,
            tax: null,
            total: null,
            reserve: null,
            higherPrice: null,
            discountPer: null,
            count: 1,
            name: '',
            terms: '',
            instalments: []
        }
    ],
    pickup: false,
    pickupComment: '',
    meetupLocation: [{ name: '', location: '' }],
    tags: []
};

const OrgActivityPackUpload = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [scroll, setScroll] = useState(false);
    const submitRef = useRef(null);
    const basicRef = useRef(null);
    const imageRef = useRef(null);
    const inExRef = useRef(null);
    const safetyRef = useRef(null);
    const thingsRef = useRef(null);
    const faqRef = useRef(null);
    const termsRef = useRef(null);
    const priceRef = useRef(null);
    const quickViewRef = useRef(null);
    const itineraryRef = useRef(null);
    const tagsRef = useRef(null);
    const timeSlotRef = useRef(null);

    const searchParams = new URLSearchParams(location.search);
    const newPack = searchParams.get('new') === 'false';
    const type = searchParams.get('type');
    const actId = searchParams.get('tripId');

    const [activityData, setActivityData] = useState(initialActivityState);
    const [loading, setLoading] = useState(false);
    const [tempData, setTempData] = useState({
        included: '',
        excluded: '',
        terms: '',
        safety: '',
        carry: ''
    });
    const [imgData, setImgData] = useState({
        oldWallImg: [],
        oldThumbImg: [],
        newWallImg: [],
        newThumbImg: []
    });
    const [isEdit, setIsEdit] = useState(false);
    const [videoFile, setVideoFile] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (scrollTop > 3000) {
                setScroll(true);
            } else {
                setScroll(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (newPack) {
            fetchPackData(actId).then((data) => {
                setActivityData(data);

                setImgData((prev) => ({
                    ...prev,
                    oldWallImg: data.images,
                    oldThumbImg: data.cardImages
                }));
                setVideoFile(data?.videos[0] || null);
                setTempData({
                    included: data.included?.join('\n'),
                    excluded: data.excluded?.join('\n'),
                    terms: data.terms?.join('\n'),
                    safety: data.safety?.join('\n'),
                    carry: data?.carry?.join('\n')
                });
                type === 'duplicate' ? setIsEdit(false) : setIsEdit(true);
                if (type === 'duplicate') {
                    setImgData({
                        oldWallImg: [],
                        oldThumbImg: [],
                        newWallImg: [],
                        newThumbImg: []
                    });
                    setVideoFile(null);
                    setActivityData((prevState) => ({
                        ...prevState,
                        meetupLocation:
                            data?.meetupLocation?.length > 0 ? data?.meetupLocation : [{ name: '', location: '' }],
                        price: [
                            {
                                actual: null,
                                tax: null,
                                total: null,
                                reserve: null,
                                higherPrice: null,
                                discountPer: null,
                                name: '',
                                terms: '',
                                count: 1,
                                instalments: []
                            }
                        ]
                    }));
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [newPack, actId, type]);

    async function fetchPackData(id) {
        try {
            const result = await orgActDetailsFun(id);
            return result.data[0];
        } catch (error) {
            errorHandle(error);
            return null;
        }
    }

    const handleSubmit = async () => {
        console.log(activityData, 'activityData');
        const res = await orgActUpSubmit(activityData, tempData, imgData, setLoading, isEdit, videoFile, {
            basicRef,
            quickViewRef,
            itineraryRef,
            imageRef,
            inExRef,
            safetyRef,
            thingsRef,
            faqRef,
            termsRef,
            priceRef,
            tagsRef,
            timeSlotRef
        });
        if (res === 200) {
            navigate('/org/a/my-activity');
        }
    };

    const handleScrollToSubmit = () => {
        if (submitRef.current) {
            submitRef.current.scrollIntoView({ behavior: 'smooth' });
            setScroll(true);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setScroll(false);
    };
    console.log(activityData);
    return (
        <div className={styles.orgPackUpDiv}>
            <button className='backBtn' onClick={() => navigate('/org/a/my-activity')}>
                <img src={BackIcon} alt='back' />
                Back to Activity
            </button>
            <div className={styles.orgPackUpDiv}>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                        <h3 style={{ marginTop: -100, fontWeight: 700, color: '#9ca3af' }} className='loadingText'>
                            It might take several minutes please wait...
                        </h3>
                    </div>
                )}
                {isEdit && activityData.status === 'active' && (
                    <div className='packEditNote'>
                        <p>
                            <span className='noteSpan'>Note:</span> Since the activity is approved, only certain parts
                            of the data can be edited.
                        </p>
                    </div>
                )}
            </div>
            <div className='sticky-containerPack'>
                {scroll ? (
                    <button onClick={scrollToTop} title='Scroll to bottom' className='sticky-button'>
                        <img src={UpArrow} alt='scroll to bottom' />
                    </button>
                ) : (
                    <button onClick={handleScrollToSubmit} title='Scroll to bottom' className='sticky-button'>
                        <img src={DownArrow} alt='scroll to bottom' />
                    </button>
                )}
            </div>
            <ActivityBasic
                ref={basicRef}
                activityData={activityData}
                setActivityData={setActivityData}
                isEdit={isEdit}
            />
            <ActivityQuickView
                ref={quickViewRef}
                activityData={activityData}
                setActivityData={setActivityData}
                isEdit={isEdit}
            />
            <AddTimeSlots
                ref={timeSlotRef}
                title={'Add Time Slots'}
                data={activityData}
                setData={setActivityData}
                dataKey={'activity'}
            />
            <ItinerarySection
                data={activityData}
                setData={setActivityData}
                title='Activity'
                itemLabel='Activity'
                minItems={1}
                ref={itineraryRef}
            />
            <ImageUpOrg
                ref={imageRef}
                imgData={imgData}
                setImgData={setImgData}
                isEdit={isEdit}
                videoFile={videoFile}
                setVideoFile={setVideoFile}
            />
            <InEx ref={inExRef} tempData={tempData} setTempData={setTempData} isEdit={isEdit} packData={activityData} />
            <Safety
                ref={safetyRef}
                tempData={tempData}
                setTempData={setTempData}
                isEdit={isEdit}
                packData={activityData}
            />
            <ThingsToCarry
                ref={thingsRef}
                tempData={tempData}
                setTempData={setTempData}
                isEdit={isEdit}
                packData={activityData}
            />
            <FAQ ref={faqRef} packData={activityData} setPackData={setActivityData} isEdit={isEdit} />
            <Terms ref={termsRef} tempData={tempData} setTempData={setTempData} />
            <ActivityPrice
                ref={priceRef}
                activityData={activityData}
                setActivityData={setActivityData}
                isEdit={isEdit}
            />
            <ActivityMeetup activityData={activityData} setActivityData={setActivityData} />
            {/* <GuidPickup guidData={activityData} setGuidData={setActivityData} /> */}
            <Tags
                data={activityData}
                setData={setActivityData}
                note={`Topics - “Scuba”, “Snorkeling”, “Rafting”, “Kayaking”, “Paragliding”, “Bungee Jump”, “Ziplining”, 
                    “Camping”, “Hiking”, “Trekking”, “Rock Climbing”, “Mountain Biking”, “Wildlife Safari”, “Hot Air Balloon”,
                     “Skiing”, “Snowboarding”, “Fishing”, “Horse Riding”, “Cultural Tour”, “Food Tour”, “Photography Tour”, “Yoga Retreat”,
                      “Meditation”, “Adventure”, “Waterfall Visit”, “Island Hopping”`}
            />
            <button ref={submitRef} type='button' className='orgPackUpSubmitBtn blueBtn' onClick={handleSubmit}>
                Submit
            </button>
        </div>
    );
};

export default OrgActivityPackUpload;
